import { render } from "./Expansion.vue?vue&type=template&id=8f970ed4&ts=true"
import script from "./Expansion.vue?vue&type=script&lang=ts"
export * from "./Expansion.vue?vue&type=script&lang=ts"

import "./Expansion.vue?vue&type=style&index=0&id=8f970ed4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__